import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';

// Styles
import { useLocalization } from '@Modal/hooks/localization/useLocalization';
import { CreateLanguageContent } from './CreateLanguageContent';

export const CreateLanguageModalDialog = () => {
  const { showCreateLanguageDialog, handleShowCreateLanguageDialog } = useLocalization();
  return (
    <>
      {showCreateLanguageDialog && (
        <ClosableModal
          name="CreateLanguage"
          title="Create Language"
          open={showCreateLanguageDialog}
          onClose={() => handleShowCreateLanguageDialog(false)}
          sx={{ width: '592px' }}
        >
          <CreateLanguageContent />
        </ClosableModal>
      )}
    </>
  );
};
